import {useMemo} from 'react';
import productSearchParams from '../utils/productSearchParams';

export default function useProductCardLink({
  badges,
  initialSelectedColorId,
  minQtyToggleSet,
  productPath,
  selectedColorId
}) {
  const promoBadges = useMemo(
    () => (badges || []).filter((badge) => badge.type === 'promo'),
    [badges]
  );

  return useMemo(() => {
    const currentSearchParams = productSearchParams(
      selectedColorId,
      promoBadges.length > 0,
      initialSelectedColorId,
      minQtyToggleSet
    );
    return currentSearchParams.toString()
      ? `${productPath}?${currentSearchParams.toString()}`
      : productPath;
  }, [
    selectedColorId,
    promoBadges.length,
    initialSelectedColorId,
    productPath,
    minQtyToggleSet
  ]);
}
